export default __webpack_public_path__ + "static/media/client-27.7d7fc9b8.webp";